export default __webpack_public_path__ + "images/87e4011848eb92495872173b7beacf9d.svg";